module.exports = __webpack_public_path__ + "static/img/logo.490de07.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1